import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

/* istanbul ignore next */
const gaOptions = {
  id: process.env.GOOGLE_ANALYTICS_ID
}
/* istanbul ignore next */
if (process.env.GOOGLE_ANALYTICS_DEBUG === '1') {
  gaOptions.debug = {
    enabled: true,
    sendHitTask: true,
    trace: true
  }
}
/* istanbul ignore next */
Vue.use(VueAnalytics, gaOptions)

/* istanbul ignore next */
Vue.mixin({
  methods: {
    handleAnalyticsTrackEvent(category, action, label, value) {
      this.$ga.event({
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      })

      this.$gtag('event', 'ua_event', {
        ua_event_action: action,
        ua_event_category: category,
        ua_event_label: label,
        ua_event_value: value
      })
    }
  }
})
